import { BorderedStack } from '@domains/subscription/priv/components'
import { createCustomTheme } from '@domains/subscription/theme'
import { ThemeProvider, Typography } from '@mui/material'
import type { BureauParent } from '../api/api'

export interface BureauParentBadgeProps {
  bureau: BureauParent | undefined
  Link: React.ComponentType<{ to: string; children: React.ReactNode }>
}

export const BureauParentBadge = ({ bureau, Link }: BureauParentBadgeProps) => {
  if (!bureau) return null

  return (
    <ThemeProvider theme={createCustomTheme()}>
      <Link to={`../customers/${bureau.bureauId}`}>
        <BorderedStack
          data-testid="bureau-parent-badge"
          sx={{
            flexDirection: 'row',
            alignItems: 'center',
            gap: 0.5,
            px: 1,
            py: 0.5,
            textAlign: 'center',
            cursor: 'pointer',
          }}
        >
          <Typography variant="p4Regular" color="textSecondary">
            Managed by
          </Typography>
          <Typography variant="p3Medium">{bureau.bureauName}</Typography>
        </BorderedStack>
      </Link>
    </ThemeProvider>
  )
}
